/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GAR } from "./GAR";
import { GARFromJSON, GARFromJSONTyped, GARToJSON, GARToJSONTyped } from "./GAR";

/**
 *
 * @export
 * @interface ApiGarGarsList200Response
 */
export interface ApiGarGarsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGarGarsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGarGarsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGarGarsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<GAR>}
   * @memberof ApiGarGarsList200Response
   */
  results: Array<GAR>;
}

/**
 * Check if a given object implements the ApiGarGarsList200Response interface.
 */
export function instanceOfApiGarGarsList200Response(
  value: object
): value is ApiGarGarsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGarGarsList200ResponseFromJSON(json: any): ApiGarGarsList200Response {
  return ApiGarGarsList200ResponseFromJSONTyped(json, false);
}

export function ApiGarGarsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGarGarsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(GARFromJSON),
  };
}

export function ApiGarGarsList200ResponseToJSON(json: any): ApiGarGarsList200Response {
  return ApiGarGarsList200ResponseToJSONTyped(json, false);
}

export function ApiGarGarsList200ResponseToJSONTyped(
  value?: ApiGarGarsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(GARToJSON),
  };
}
